import { render, staticRenderFns } from "./DeleteUserTask.vue?vue&type=template&id=5e6d6d79"
import script from "./DeleteUserTask.vue?vue&type=script&lang=js"
export * from "./DeleteUserTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports